import { faFloppyDisk } from '@fortawesome/pro-regular-svg-icons';
import { Group, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { DisplayCreative } from '@feathr/blackbox';
import { Button, ContextMenu, FullScreenModal, Heading, Icon, Pill } from '@feathr/components';

import PreviewPanel from './PreviewPanel';

import * as styles from './CreativeModal.css';

export interface ICreativeModalProps {
  creative?: DisplayCreative;
  opened: boolean;
  onClose: () => void;
}

function CreativeModal({ creative, opened, onClose }: Readonly<ICreativeModalProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const title = (
    <Group gap={theme.spacing['2']}>
      <span>{t('Preview creative')}</span>
      <Pill>{creative?.creativeType ?? t('Image')}</Pill>
    </Group>
  );

  const rightActions = (
    <>
      <ContextMenu iconName={'ellipsis'} name={'creative-modal-actions'}>
        <ContextMenu.Item>{t('Placeholder action')}</ContextMenu.Item>
      </ContextMenu>
      <Button
        name={'creative-modal-save'}
        onClick={onClose}
        prefix={<Icon icon={faFloppyDisk} />}
        type={'primary'}
      >
        {t('Save and close')}
      </Button>
    </>
  );

  return (
    <FullScreenModal
      className={styles.modal}
      closeOnEscape={false}
      onClose={onClose}
      opened={opened}
      rightActions={rightActions}
      theme={'flush'}
      title={title}
    >
      <div className={styles.body}>
        <div className={styles.previewArea}>
          <PreviewPanel
            contentHeight={creative?.get('height')}
            contentWidth={creative?.get('width')}
            creativeName={creative?.name}
            imageUrl={creative?.get('url')}
            isMetaCreative={creative?.isFacebook}
          />
        </div>
        <div className={styles.sidebar}>
          <Heading order={4} variant={'h4'}>
            {t('Edit Details')}
          </Heading>
        </div>
      </div>
    </FullScreenModal>
  );
}

export default CreativeModal;
